import styles from './FormInputGroup.module.scss';

interface FormInputGroupProps {
    children: React.ReactNode;
}

/**
 * thin wrapper for form inputs to correctly space them apart
 * @param children - Form Input ReactNodes
 * @returns form input wrapper
 */
export function FormInputGroup({ children }: FormInputGroupProps) {
    return (
        <div className={styles.formInputGroup} data-testid="form-input-group">
            {children}
        </div>
    );
}
